import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import util from '@/libs/util';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pics: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      title: '',
      saveLoading: false,
      markLoading: false,
      uploadUrl: process.env.VUE_APP_API,
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      headUploadVisible: false,
      bgUploadVisible: false,
      albumUploadVisible: false,
      headFileList: [],
      bgFileList: [],
      albumFileList: [],
      picsData: [],
      memberForm: {
        matchmakerViewSts: 0,
        matchmakerViewEndTime: null
      },
      memberInfoForm: {
        aboutMe: '',
        monologue: '',
        familySituation: '',
        hisFavorite: ''
      },
      sexList: [{
        keys: '男',
        values: '男'
      }, {
        keys: '女',
        values: '女'
      }],
      heightList: function () {
        var list = [];
        for (var i = 140; i <= 210; i++) {
          list.push({
            keys: i + 'cm',
            values: i + ''
          });
        }
        return list;
      }(),
      weightList: function () {
        var list = [];
        for (var i = 40; i <= 200; i++) {
          list.push({
            keys: i + 'kg',
            values: i + ''
          });
        }
        return list;
      }(),
      membershipTypeList: [{
        keys: '单身',
        values: '单身'
      }, {
        keys: '家长',
        values: '家长'
      }],
      marriageList: [],
      educationList: [],
      zodiacList: [],
      annualIncomeList: [],
      buyHouseList: [],
      carPurchaseList: [],
      citys: [],
      selectCitys: [],
      selectNativePlace: [],
      cityProps: {
        multiple: false
      }
    };
  },
  computed: {
    // 家乡籍贯只选到二级(省→市)，从同一份城市树裁剪掉三级(区)数据
    nativePlaceOptions: function nativePlaceOptions() {
      var list = [];
      for (var i = 0; i < this.citys.length; i++) {
        var province = this.citys[i];
        var cities = [];
        for (var j = 0; j < (province.children || []).length; j++) {
          var city = province.children[j];
          cities.push({
            value: city.value,
            label: city.label
          });
        }
        list.push({
          value: province.value,
          label: province.label,
          children: cities
        });
      }
      return list;
    }
  },
  watch: {
    pics: {
      handler: function handler(val) {
        this.picsData = val || [];
      }
    }
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    ifPicUrl: function ifPicUrl(url) {
      if (!url) return '';
      if (url.indexOf('http') !== -1) {
        return url;
      }
      return this.downloadUrl + url;
    },
    // 枚举值归一化：已是values直接用；是keys(显示文本)转回values；否则原样返回
    enumsToValues: function enumsToValues(list, value) {
      if (value === undefined || value === null || value === '') {
        return value;
      }
      var str = value + '';
      // 优先按values匹配，返回枚举原值保证与下拉option类型一致
      var hit = list.find(function (item) {
        return item.values + '' === str;
      });
      if (hit) {
        return hit.values;
      }
      var hit2 = list.find(function (item) {
        return item.keys + '' === str;
      });
      return hit2 ? hit2.values : value;
    },
    getEnums: function getEnums() {
      var thiz = this;
      return Promise.all([api.GET_ENUMERATION_LIST({
        name: 'mbmber_marriage_select'
      }).then(function (res) {
        thiz.marriageList = res.body;
      }), api.GET_ENUMERATION_LIST({
        name: 'mbmber_education_select'
      }).then(function (res) {
        thiz.educationList = res.body;
      }), api.GET_ENUMERATION_LIST({
        name: 'member_zodiac'
      }).then(function (res) {
        thiz.zodiacList = res.body;
      }), api.GET_ENUMERATION_LIST({
        name: 'member_annual_income'
      }).then(function (res) {
        thiz.annualIncomeList = res.body;
      }), api.GET_ENUMERATION_LIST({
        name: 'member_buyHouse_select'
      }).then(function (res) {
        thiz.buyHouseList = res.body;
      }), api.GET_ENUMERATION_LIST({
        name: 'member_car_select'
      }).then(function (res) {
        thiz.carPurchaseList = res.body;
      }), api.GET_BYCITYOPENING_TREE_LIST({}).then(function (res) {
        thiz.citys = res.body;
      })]);
    },
    setData: function setData(form, pics) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var provinceCode, cityCode, areaCode, nativeProvince, nativeCity, matchCodes, npLabels;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _this.getEnums();
            case 1:
              _this.picsData = pics || [];
              _this.memberForm = Object.assign({}, form);
              // 去掉详情页拼接的单位后缀，编辑保存的是纯数字
              _this.memberForm.height = (_this.memberForm.height || '').toString().replace(/cm+$/i, '');
              _this.memberForm.weight = (_this.memberForm.weight || '').toString().replace(/kg+$/i, '');
              // 列表/详情接口返回的是枚举中文文本，需转回枚举values，否则下拉回显空白、保存会写脏值
              // 性别兼容老数据main/women，统一转成中文男/女
              _this.memberForm.sex = _this.enumsToValues(_this.sexList, {
                main: '男',
                women: '女'
              }[_this.memberForm.sex] || _this.memberForm.sex);
              _this.memberForm.education = _this.enumsToValues(_this.educationList, _this.memberForm.education);
              _this.memberForm.marriage = _this.enumsToValues(_this.marriageList, _this.memberForm.marriage);
              _this.memberForm.buyHouse = _this.enumsToValues(_this.buyHouseList, _this.memberForm.buyHouse);
              _this.memberForm.carPurchase = _this.enumsToValues(_this.carPurchaseList, _this.memberForm.carPurchase);
              _this.memberForm.zodiac = _this.enumsToValues(_this.zodiacList, _this.memberForm.zodiac);
              _this.memberForm.annualIncome = _this.enumsToValues(_this.annualIncomeList, _this.memberForm.annualIncome);
              // 红娘查看权限：接口空值兜底为未开通(0)，结束时间空值置null避免显示undefined
              _this.memberForm.matchmakerViewSts = form.matchmakerViewSts != null ? Number(form.matchmakerViewSts) : 0;
              _this.memberForm.matchmakerViewEndTime = form.matchmakerViewEndTime || null;
              _this.memberInfoForm = {
                aboutMe: form.aboutMe || '',
                monologue: form.monologue || '',
                familySituation: form.familySituation || '',
                hisFavorite: form.hisFavorite || ''
              };
              _this.selectCitys = [];
              // 兼容旧数据(provinceCode)与最新原始数据(province)两种字段
              provinceCode = form.provinceCode || form.province;
              cityCode = form.cityCode || form.city;
              areaCode = form.areaCode || form.area;
              if (provinceCode && cityCode && areaCode) {
                _this.selectCitys = [provinceCode + '', cityCode + '', areaCode + ''];
              } else if (provinceCode && cityCode) {
                _this.selectCitys = [provinceCode + '', cityCode + ''];
              } else if (provinceCode) {
                _this.selectCitys = [provinceCode + ''];
              }
              // 家乡籍贯回显（member_info.native_province / native_city 存的是城市树id）
              _this.selectNativePlace = [];
              nativeProvince = form.nativeProvince;
              nativeCity = form.nativeCity;
              if (nativeProvince && nativeCity) {
                _this.selectNativePlace = [nativeProvince + '', nativeCity + ''];
              } else if (nativeProvince) {
                _this.selectNativePlace = [nativeProvince + ''];
              } else {
                // 旧数据可能只有籍贯文本(如"四川 成都")，按城市树标签匹配回显
                matchCodes = _this.matchNativePlaceToCodes(form.nativePlace);
                if (matchCodes) {
                  _this.selectNativePlace = matchCodes;
                }
              }
              // 只有省/市code没有籍贯文本时，从选中项拼出文本，保证再次保存时文本一并落库
              if (!_this.memberForm.nativePlace && _this.selectNativePlace.length) {
                npLabels = _this.nativePlaceLabels();
                if (npLabels.length) {
                  _this.memberForm.nativePlace = npLabels.join(' ');
                }
              }
              // 加载带ID的图片列表
              _context.n = 2;
              return _this.loadPictures(form.memberId);
            case 2:
              // 回显头像
              _this.headFileList = [];
              if (form.headUrl) {
                _this.headFileList = [{
                  name: '头像',
                  url: _this.ifPicUrl(form.headUrl),
                  status: 'success',
                  uid: Date.now()
                }];
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    loadPictures: function loadPictures(memberId) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, allPics, bgPic, albumPics, i;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_MEMBERPICTURES_DETAIL_LIST({
                memberId: memberId
              });
            case 1:
              res = _context2.v;
              allPics = res.body || []; // 回显背景（imageType=0）
              _this2.bgFileList = [];
              bgPic = allPics.find(function (p) {
                return p.imageType === 0;
              });
              if (bgPic) {
                _this2.bgFileList = [{
                  name: '背景',
                  url: _this2.ifPicUrl(bgPic.url),
                  picturesId: bgPic.picturesId,
                  status: 'success',
                  uid: Date.now()
                }];
              }
              // 回显相册（imageType=1）
              _this2.albumFileList = [];
              albumPics = allPics.filter(function (p) {
                return p.imageType === 1;
              });
              for (i = 0; i < albumPics.length; i++) {
                _this2.albumFileList.push({
                  name: '相册' + i,
                  url: _this2.ifPicUrl(albumPics[i].url),
                  picturesId: albumPics[i].picturesId,
                  status: 'success',
                  uid: Date.now() + i
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleClose: function handleClose() {
      this.$emit('close');
    },
    birthdayChange: function birthdayChange(val) {
      // 根据出生日期自动计算周岁年龄
      if (!val) {
        this.memberForm.age = '';
        return;
      }
      var birthDate = new Date(val);
      var now = new Date();
      var age = now.getFullYear() - birthDate.getFullYear();
      var monthDiff = now.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || monthDiff === 0 && now.getDate() < birthDate.getDate()) {
        age--;
      }
      this.memberForm.age = age;
    },
    headUploadSuccess: function headUploadSuccess(res) {
      var _this3 = this;
      var headUrl = res.body.url;
      api.UPDATE_MEMBER_BASIC_INFO({
        memberId: this.memberForm.memberId,
        headUrl: headUrl
      }).then(function () {
        _this3.$message.success('头像上传成功');
        _this3.headUploadVisible = false;
        _this3.headFileList = [{
          name: '头像',
          url: _this3.ifPicUrl(headUrl),
          status: 'success',
          uid: Date.now()
        }];
        _this3.memberForm.headUrl = headUrl;
        _this3.$emit('initTableData');
      });
    },
    headFileChange: function headFileChange(file, fileList) {
      // 只保留最新选中的文件，实现替换而不是增加
      if (fileList.length > 1) {
        this.headFileList = fileList.slice(-1);
      }
    },
    bgUploadSuccess: function bgUploadSuccess(res) {
      var _this4 = this;
      var data = {
        memberId: this.memberForm.memberId,
        name: res.body.name,
        url: JSON.stringify(res.body)
      };
      api.SAVE_MEMBER_CENTRE_BACKGROUND(data).then(function () {
        _this4.$message.success('背景上传成功');
        _this4.bgUploadVisible = false;
        _this4.bgFileList = [{
          name: '背景',
          url: res.body.url,
          status: 'success',
          uid: Date.now()
        }];
        _this4.$emit('initTableData');
      });
    },
    bgFileChange: function bgFileChange(file, fileList) {
      // 只保留最新选中的文件，实现替换而不是增加
      if (fileList.length > 1) {
        this.bgFileList = fileList.slice(-1);
      }
    },
    albumUploadSuccess: function albumUploadSuccess(res) {
      this.albumFileList.push({
        name: res.body.name,
        url: this.downloadUrl + res.body.url,
        response: res
      });
    },
    albumRemove: function albumRemove(file, fileList) {
      var _this5 = this;
      if (file.picturesId) {
        api.DELETE_MEMBERPICTURES({
          picturesId: file.picturesId
        }).then(function () {
          _this5.$message.success('相册图片删除成功');
          _this5.albumFileList = fileList;
          _this5.$emit('initTableData');
        });
      } else {
        this.albumFileList = fileList;
      }
    },
    saveAlbum: function saveAlbum() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var images, i, item, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(_this6.albumFileList.length === 0)) {
                _context3.n = 1;
                break;
              }
              _this6.$message.error('请至少上传一张照片');
              return _context3.a(2);
            case 1:
              images = [];
              for (i = 0; i < _this6.albumFileList.length; i++) {
                item = _this6.albumFileList[i];
                if (item.response) {
                  images.push(item.response.body);
                }
              }
              if (!(images.length === 0)) {
                _context3.n = 2;
                break;
              }
              _this6.albumUploadVisible = false;
              return _context3.a(2);
            case 2:
              data = {
                memberId: _this6.memberForm.memberId,
                fileList: images
              };
              _context3.n = 3;
              return api.ADD_MEMBER_PIC(data);
            case 3:
              _this6.$message.success('相册上传成功');
              _this6.albumUploadVisible = false;
              _this6.albumFileList = [];
              _this6.$emit('initTableData');
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 城市code转数字，非数字返回null，避免脏数据传给后端Integer字段
    cityCodeToInt: function cityCodeToInt(v) {
      var n = parseInt(v, 10);
      return isNaN(n) ? null : n;
    },
    nativePlaceChange: function nativePlaceChange(value) {
      // element-ui cascader 的 change 事件只回传 value，不提供 selectedOptions；
      // 改为按已选中的省/市 code 从城市树反查名称，格式与移动端一致："省份 城市"
      var labels = this.nativePlaceLabels();
      this.memberForm.nativePlace = labels.length ? labels.join(' ') : '';
    },
    // 根据已选的省/市code从二级城市树取名称列表
    nativePlaceLabels: function nativePlaceLabels() {
      var labels = [];
      var prov = this.selectNativePlace[0];
      var city = this.selectNativePlace[1];
      for (var i = 0; i < this.nativePlaceOptions.length; i++) {
        var p = this.nativePlaceOptions[i];
        if (prov && p.value + '' === prov + '') {
          labels.push(p.label);
          for (var j = 0; j < (p.children || []).length; j++) {
            var c = p.children[j];
            if (city && c.value + '' === city + '') {
              labels.push(c.label);
              break;
            }
          }
          break;
        }
      }
      return labels;
    },
    // 旧数据只有籍贯文本时(如"四川 成都")，按城市树标签匹配出[省id, 市id]用于回显；匹配不到返回null
    matchNativePlaceToCodes: function matchNativePlaceToCodes(text) {
      if (!text) return null;
      var parts = text.trim().split(/\s+/);
      var clean = function clean(name) {
        return (name || '').replace(/省|市|自治区|自治州|地区|特别行政区/g, '');
      };
      var provinceName = clean(parts[0]);
      if (!provinceName) return null;
      for (var i = 0; i < this.citys.length; i++) {
        var province = this.citys[i];
        if (province.label !== provinceName) continue;
        if (parts.length < 2) return [province.value + ''];
        var cityName = clean(parts[1]);
        for (var j = 0; j < (province.children || []).length; j++) {
          var city = province.children[j];
          if (city.label === cityName) {
            return [province.value + '', city.value + ''];
          }
        }
        return [province.value + ''];
      }
      return null;
    },
    save: function save() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var memberData, memberInfoData, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _this7.saveLoading = true;
              _context4.p = 1;
              memberData = {
                memberId: _this7.memberForm.memberId,
                nickName: _this7.memberForm.nickName,
                sex: _this7.memberForm.sex,
                age: _this7.memberForm.age,
                education: _this7.memberForm.education,
                marriage: _this7.memberForm.marriage,
                buyHouse: _this7.memberForm.buyHouse,
                carPurchase: _this7.memberForm.carPurchase,
                name: _this7.memberForm.name,
                idNo: _this7.memberForm.idNo,
                wxchatUserName: _this7.memberForm.wxchatUserName,
                membershipType: _this7.memberForm.membershipType,
                matchmakerViewSts: _this7.memberForm.matchmakerViewSts,
                matchmakerViewEndTime: _this7.memberForm.matchmakerViewEndTime,
                province: _this7.selectCitys.length > 0 ? _this7.cityCodeToInt(_this7.selectCitys[0]) : null,
                city: _this7.selectCitys.length > 1 ? _this7.cityCodeToInt(_this7.selectCitys[1]) : null,
                area: _this7.selectCitys.length > 2 ? _this7.cityCodeToInt(_this7.selectCitys[2]) : null
              };
              _context4.n = 2;
              return api.UPDATE_MEMBER_BASIC_INFO(memberData);
            case 2:
              memberInfoData = {
                memberId: _this7.memberForm.memberId,
                birthday: _this7.memberForm.birthday,
                height: _this7.memberForm.height,
                weight: _this7.memberForm.weight,
                zodiac: _this7.memberForm.zodiac,
                occupation: _this7.memberForm.occupation,
                nativePlace: _this7.memberForm.nativePlace || '',
                nativeProvince: _this7.selectNativePlace.length > 0 ? _this7.cityCodeToInt(_this7.selectNativePlace[0]) : null,
                nativeCity: _this7.selectNativePlace.length > 1 ? _this7.cityCodeToInt(_this7.selectNativePlace[1]) : null,
                annualIncome: _this7.memberForm.annualIncome,
                aboutMe: _this7.memberInfoForm.aboutMe,
                monologue: _this7.memberInfoForm.monologue,
                familySituation: _this7.memberInfoForm.familySituation,
                hisFavorite: _this7.memberInfoForm.hisFavorite
              };
              _context4.n = 3;
              return api.UPDATE_MEMBER_DETAIL_INFO(memberInfoData);
            case 3:
              _this7.$message.success('保存成功');
              _this7.$emit('initTableData');
              _this7.handleClose();
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              _this7.$message.error('保存失败');
            case 5:
              _context4.p = 5;
              _this7.saveLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 4, 5, 6]]);
      }))();
    },
    markComplete: function markComplete() {
      var _this8 = this;
      this.$confirm('确定将该会员标记为资料已完善吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this8.markLoading = true;
        api.MARK_MEMBER_INFORMATION_COMPLETE({
          memberId: _this8.memberForm.memberId
        }).then(function () {
          _this8.$message.success('已标记为完善');
          _this8.$emit('initTableData');
        }).catch(function () {
          _this8.$message.error('标记失败');
        }).finally(function () {
          _this8.markLoading = false;
        });
      }).catch(function () {});
    }
  }
};